module.exports = __webpack_public_path__ + "fonts/fa-regular-400.3ac49cb3.eot";